import get from 'lodash.get'

import LENDER_SLAG_TO_TRACKING_NAME_MAP from 'common/const/lenderSlagToTrackingNameMap'
import { PERSONAL, REFI, INSCHOOL } from 'common/const/verticalNames'

const verticalToPostfixMap = {
  [PERSONAL]: '_pl',
  [REFI]: '_slr',
  [INSCHOOL]: '_psl',
}

const mapLenderSlagToTrackingName = (lenderSlug, vertical) => {
  const postfix = verticalToPostfixMap[vertical] || ''

  return get(LENDER_SLAG_TO_TRACKING_NAME_MAP, [vertical, lenderSlug])
    ? `${LENDER_SLAG_TO_TRACKING_NAME_MAP[vertical][lenderSlug]}${postfix}`
    : `${lenderSlug}${postfix}`
}

export default mapLenderSlagToTrackingName
